


















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Warnings } from "@/models/CaseModel";
import RegisterCaseWarnings from "./register-case-warnings.vue";

interface Error {
    error: any[];
    isError: boolean;
}

@Component
export default class RegisterCaseLayout extends Vue {
    @Prop({ default: false })
    loading!: boolean;

    @Prop({ default: { msg: "", isError: false } })
    error!: Error;

    @Prop({ default: false })
    isDisabled!: boolean;

    @Prop({ default: false })
    resetObserver!: boolean;

    @Prop()
    warnings!: Warnings;

    isDevelopment() {
        return process.env.NODE_ENV === 'development';
    }

    created() {
        if (this.error.isError) {
            this.errorOccurred();
        }
    }

    @Watch("error")
    onError() {
        if (this.error.isError) {
            this.errorOccurred();
        }
    }

    @Watch("resetObserver")
    onReset() {
        if (this.resetObserver) {
            const observer: any = this.$refs.observer;
            observer.reset();
            this.$emit("reset");
        }
    }

    onSave() {
        const warnings = Object.values(this.warnings).filter(w => w);
        if (warnings.length > 0) {
            this.$buefy.modal.open({
                parent: this,
                component: RegisterCaseWarnings,
                props: { warnings },
                events: {
                    save: () => this.$emit("save")
                },
                width: 500
            });
        } else {
            this.$emit("save");
        }
    }

    errorOccurred() {
        this.$buefy.dialog.confirm({
            title: this.$t('registerCases.errorTitle') as string,
            message: this.$t('registerCases.errorMessage') as string,
            confirmText: this.$t('registerCases.errorConfirm') as string,
            cancelText: this.$t('registerCases.errorCancel') as string,
            type: "is-info",
            hasIcon: true,
            onConfirm: () => {
                this.$buefy.toast.open(this.$t('registerCases.errorToast') as string);
                this.$router.push({ name: "home" });
            },
            onCancel: () => this.$router.push({ name: "home" })
        });
    }
}

